/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import ChatBotNuanceErrorMessage from "src/app/components/ChatBotNuanceErrorMessage";
import PropTypes from "prop-types";
import { setChatWidgetParam } from "../../utilities/sierraChat";
import CardSection from "../CardSection/CardSection";
import styles from "./SierraChatButton.module.css";
import { withTranslation } from "@asosteam/asos-web-react-i18n";

const SierraChatButton = ({
  sierraLoadError,
  isWebView,
  formatTranslation,
}) => {
  if (sierraLoadError) {
    return <ChatBotNuanceErrorMessage />;
  }

  return (
    <CardSection
      title={formatTranslation("cchp_ai_chat_need_help")}
      onClick={setChatWidgetParam}
    >
      <a
        className={styles.anchor}
        onClick={!isWebView ? setChatWidgetParam : null}
        href={isWebView ? "asos://chat" : ""}
      >
        {formatTranslation("cchp_ai_chat_start_chat_button")}
      </a>
    </CardSection>
  );
};

SierraChatButton.propTypes = {
  isWebView: PropTypes.bool,
  sierraLoadError: PropTypes.bool,
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(SierraChatButton);
